export default "__VITE_ASSET__BKiSM14o__"